const Bugsnag = require('@bugsnag/js');
const BugsnagPluginReact = require('@bugsnag/plugin-react');
const { AuthErrors } = require('@/constants/users');
const { isNetworkError } = require('@/constants/common');

const INJECTED_NOISE_SIGNATURE = ['Object Not Found Matching Id', 'MethodName', 'ParamCount'];

const hasInjectedNoiseSignature = (text) =>
  typeof text === 'string' && INJECTED_NOISE_SIGNATURE.every((token) => text.includes(token));

const isInjectedNonActionableNoise = (event, err) => {
  if (hasInjectedNoiseSignature(err)) return true;
  if (hasInjectedNoiseSignature(err?.message)) return true;
  try {
    const meta = event.getMetadata && event.getMetadata('unhandledrejection handler');
    if (meta && hasInjectedNoiseSignature(JSON.stringify(meta))) return true;
  } catch {
    return false;
  }
  return false;
};

Bugsnag.start({
  apiKey: process.env.BUGSNAG_API_KEY,
  plugins: [new BugsnagPluginReact()],
  releaseStage: process.env.APP_ENV,
  enabledReleaseStages: ['production', 'staging', 'development'],
  onError: function (event) {
    const err = event.originalError;
    if (err?.message === AuthErrors.loginRequired) return false;
    if (isInjectedNonActionableNoise(event, err)) return false;
    if (err?.message?.includes('marker.io') || err?.stack?.includes('marker.io')) return false;
    if (isNetworkError(err)) {
      if (err.wasOffline) return false;
      event.addMetadata('network', { online: true });
      return;
    }
    if (err?.responseStatus >= 500 && err.responseStatus < 600) return false;
    if (err?.requestPayload) event.addMetadata('request', err.requestPayload);
  },
});

module.exports = Bugsnag;
